import React from "react";
import Slider from "react-slick";

const BannerOne = () => {

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <section className="banner">
      <div className="container-fluid p-0">
        <Slider {...settings} className="banner-slider">

          <div className="banner-slide">
            <img
              // src="/assets/images/banners/mainbanner.jpg"
              src="/assets/images/banners/ak.png"
              alt="Banner 1"
              className="img-fluid w-100 banner-img maindd"
            />
          </div>

          <div className="banner-slide">
            <img
              src="/assets/images/banners/ak11.png"
              alt="Banner 2"
              className="img-fluid w-100  banner-img maindd"
            />
          </div>

          <div className="banner-slide">
            <img
              src="/assets/images/banners/ak22.png"
              alt="Banner 3"
              className="img-fluid w-100 banner-img maindd"
            />
          </div>

          <div className="banner-slide">
            <img
              src="/assets/images/banners/ak33.png"
              alt="Banner 4"
              className="img-fluid w-100 banner-img maindd"
            />
          </div>

          <div className="banner-slide">
            <img
              src="/assets/images/banners/ak44.png"
              alt="Banner 3"
              className="img-fluid w-100 banner-img maindd"
            />
          </div>

          <div className="banner-slide">
            <img
              src="/assets/images/banners/ak55.png"
              alt="Banner 4"
              className="img-fluid w-100 banner-img maindd"
            />
          </div>

        </Slider>
      </div>
    </section>
  );
};

export default BannerOne;
